// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"bc91d755","960":"f08ccb56"}[chunkId] + ".chunk.js";
};